var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.2402C13.4594 16.2402 17 12.7884 17 8.62012C17 4.45185 13.4594 1 9 1C4.54064 1 1 4.45185 1 8.62012C1 12.7884 4.54064 16.2402 9 16.2402ZM9 17.2402C13.9706 17.2402 18 13.3809 18 8.62012C18 3.85936 13.9706 0 9 0C4.02944 0 0 3.85936 0 8.62012C0 13.3809 4.02944 17.2402 9 17.2402Z",
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58984 6.37207V13.2402H8.40918V6.37207H9.58984ZM8.32031 4.55029C8.32031 4.35986 8.37744 4.19906 8.4917 4.06787C8.61019 3.93669 8.78369 3.87109 9.01221 3.87109C9.23649 3.87109 9.40788 3.93669 9.52637 4.06787C9.64909 4.19906 9.71045 4.35986 9.71045 4.55029C9.71045 4.73226 9.64909 4.88883 9.52637 5.02002C9.40788 5.14697 9.23649 5.21045 9.01221 5.21045C8.78369 5.21045 8.61019 5.14697 8.4917 5.02002C8.37744 4.88883 8.32031 4.73226 8.32031 4.55029Z",
    fill: "#B7B7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.1b0d30dd1fa2e901c8e80d54fc4e2ac5.svg";
export { ForwardRef as ReactComponent };